import styled from 'styled-components';
import colors from '../../../config/colors.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 5px;
    padding: 33px;
    background-color: ${colors.light};
    flex: 1;

    .content-header {
      
      img.icon {
        max-width: 55px;
        margin-top: 10px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    h4 {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 16px;
        letter-spacing: 0;
        color: ${colors.softDark};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        margin-top: 16px;
        line-height: 25px;
      }

    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.black};
        font-size: 12px;
        text-align: center;
        margin: 6px 0 20px 0;
        line-height: 18px;
        padding: 0 50px;
    }

    button {
        background: ${colors.lightRed} 0% 0% no-repeat padding-box;
        border: 1px solid ${colors.lightRed};
        border-radius: 8px;
        opacity: 1;
        height: 40px;
        color: ${colors.light};
        font-size: 12px;
        font-weight: bold;
        max-width: 138px;
        line-height: 18px;
        width: 100%;
        margin-bottom: 28px;
    }

    a {
        text-decoration: none;
        color: ${colors.light};
    }
`;
